import { DeviceType } from '../../ts/models/DeviceType';
import { IGroupInfo } from '../../ts/models/IGroupInfo';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { IExplorableItemTypeInfo, INamedItemInfo, IOwnedItemInfo } from '../../ts/models/resourceInfoParts';
import { DataAlertContextType, DataAlertRecipientType, DataAlertSuspendState } from '../serverApi/types/IDataAlert';

export interface IDataAlertBase extends INamedItemInfo, IOwnedItemInfo, IExplorableItemTypeInfo<'dataalert'> {}

export interface IDataAlertInfo extends IDataAlertBase {
  context: DataAlertContextInfo;
  displayRecipients: DataAlertRecipientInfo[];
  recipientsCount: number;
  isCurrentUserSubscribed: boolean;
  lastChecked?: Date;
  lastSentForCurrentUser?: Date;
  notificationIntervalInMinutes: number;
  deviceType: DeviceType;
  suspendState: DataAlertSuspendState;
  isPublic: boolean;
}

export const DataAlertRecipientInfoType = {
  isUser: (r: DataAlertRecipientInfo): r is UserDataAlertRecipientInfo => r.type === 'user',
  isGroup: (r: DataAlertRecipientInfo): r is GroupDataAlertRecipientInfo => r.type === 'group'
};

export interface DataAlertRecipientInfo {
  type: DataAlertRecipientType;
}

export interface UserDataAlertRecipientInfo extends DataAlertRecipientInfo {
  user: IUserInfo;
}

export interface GroupDataAlertRecipientInfo extends DataAlertRecipientInfo {
  group: IGroupInfo;
}

export interface DataAlertContextInfo extends INamedItemInfo {
  type: DataAlertContextType;
  path: string;
  isViewModified: boolean;
}
